import type { ViewerProfile } from "../backend/api";
import { offlineDatabase } from "./database";
import { rememberCurrentOwner } from "./trackingStore";

const VIEWER_PROFILE_KEY = "profile:viewer";

export async function cacheViewerProfile(profile: ViewerProfile) {
  await offlineDatabase.transaction(
    "rw",
    offlineDatabase.privateSnapshots,
    offlineDatabase.localSession,
    async () => {
      await offlineDatabase.privateSnapshots.put({
        ownerId: profile.userId,
        key: VIEWER_PROFILE_KEY,
        payload: profile,
        updatedAt: Date.now(),
      });
      await rememberCurrentOwner(profile.userId);
    },
  );
}

/**
 * The snapshot for one account.
 *
 * `ownerId` is passed in rather than read from the `current-owner` marker: a
 * session that ends without `secureSignOut` leaves that marker on the previous
 * account, and the next person to sign in on this browser would be handed their
 * profile. Looking it up under the authenticated id means a stale partition
 * simply misses.
 */
export async function readCachedViewerProfile(ownerId: string | null) {
  if (ownerId === null) return null;
  const record = await offlineDatabase.privateSnapshots.get([ownerId, VIEWER_PROFILE_KEY]);
  return (record?.payload as ViewerProfile | undefined) ?? null;
}
